import { Card, Grid, Tab, Tabs } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';
import { SVGIconComponent } from '../../icons/types';
import { HubCardHeader, HubCardHeaderProps } from '../hub-card-header/hub-card-header.component';
import { useHubCardStyles } from './hub-card.styles';
import { PermissionBoundary } from '../../../../../core/permissions/permission-boundary.component';

export type HubCardProps = PropsWithChildren<{
  headerProps: HubCardHeaderProps;
  isDoubleSided: boolean;
  sideSelectOptions: string[];
  selectedSide: string | undefined;
  onSelectSide(label: string): void;
  transactionTypes?: { value: string; icon: SVGIconComponent }[];
  onTransactionTypeHover?: (type: string | null) => void;
  transactionTypesRightSlot?: ReactNode;
  hideHeader?: boolean;
  hideCardFrame?: boolean;
}>;

export function HubCard({
  headerProps,
  children,
  isDoubleSided,
  onSelectSide,
  selectedSide,
  sideSelectOptions,
  transactionTypes,
  onTransactionTypeHover,
  transactionTypesRightSlot,
  hideHeader,
  hideCardFrame
}: HubCardProps) {
  const classes = useHubCardStyles({
    removeToPadding: isDoubleSided
  });
  const body = (
    <Grid container>
      {!hideHeader && (
        <Grid container>
          <HubCardHeader {...headerProps} />
        </Grid>
      )}
      {isDoubleSided && selectedSide ? (
        <Tabs
          className={classes.hubSideToggleTabs}
          classes={{
            root: classes.hubSideToggleTabs,
            indicator: classes.hubSideToggleTabsIndicator
          }}
          value={selectedSide}
          onChange={(_, newValue) => onSelectSide(newValue)}
          aria-label="Double Sided Tower Side Selection"
        >
          {sideSelectOptions.map((side) => (
            <Tab
              key={side}
              id={side}
              classes={{
                root: classes.hubSideToggleTab,
                selected: classes.hubSideToggleTabSelected
              }}
              label={`"${side.toUpperCase()}" SIDE`}
              value={side}
              aria-controls={side}
              style={{ fontSize: '14px' }}
            />
          ))}
        </Tabs>
      ) : null}

      <Grid className={classes.towerContainer} container wrap="nowrap">
        {children}
      </Grid>
      {transactionTypes && transactionTypes.length > 0 && (
        <PermissionBoundary availableUiFeatures={['internal-groundfloor']}>
          <Grid container>
            <div className={classes.transactionTypesContainer}>
              <span>Highlight availability for:&nbsp;</span>
              {transactionTypes.map((tt) => (
                <div
                  key={tt.value}
                  className={classes.transactionTypeIcon}
                  onMouseEnter={() => onTransactionTypeHover?.(tt.value)}
                  onMouseLeave={() => onTransactionTypeHover?.(null)}
                >
                  <tt.icon className={classes.transactionTypeIconSvg} />
                </div>
              ))}
              {transactionTypesRightSlot && (
                <div className={classes.transactionTypesRightSlot}>{transactionTypesRightSlot}</div>
              )}
            </div>
          </Grid>
        </PermissionBoundary>
      )}
    </Grid>
  );
  return hideCardFrame ? body : <Card className={classes.card}>{body}</Card>;
}
